<template>
    <main>
        <nav
            class="navbar fixed-top navbar-expand-md navbar-light navbar-laravel"
        >
            <div class="container">
                <span class="navbar-brand">
                    Ashmore Maps
                </span>

                <button
                    class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div
                    class="collapse navbar-collapse"
                    id="navbarSupportedContent"
                >
                    <!-- Left Side Of Navbar -->
                    <ul class="navbar-nav mr-auto"></ul>

                    <!-- Right Side Of Navbar -->
                    <ul class="navbar-nav ml-auto">
                        <!-- Authentication Links -->
                        <li v-if="!is_admin" class="nav-item">
                            <a class="nav-link icon-user" href="/login"
                                >Admin Login</a
                            >
                        </li>
                        <li v-if="is_admin" class="nav-item">
                            <router-link
                                :to="`/map/admin/`"
                                class="nav-link icon-map-o"
                            >
                                Admin Console
                            </router-link>
                        </li>
                        <li v-if="is_admin" class="nav-item">
                            <a
                                class="nav-link icon-ok-circle mx-2"
                                style="position:relative;"
                                href="/donotcall"
                            >
                                Approvals
                                <div
                                    v-if="dnc_count"
                                    class="badge badge-danger"
                                >
                                    {{ dnc_count }}
                                </div>
                            </a>
                        </li>

                        <li class="nav-item">
                            <a class="icon-qrcode nav-link" href="/showkey">
                                Show Map Link QR Code
                            </a>
                        </li>

                        <li v-if="$screenfull.enabled" class="nav-item">
                            <a
                                @click="
                                    collapseNav();
                                    $screenfull.toggle();
                                "
                                class="nav-link icon-resize-full"
                                href="#"
                            >
                                Toggle Full-Screen
                            </a>
                        </li>

                        <li v-if="is_admin" class="nav-item dropdown">
                            <a
                                id="navbarDropdown"
                                class="nav-link dropdown-toggle icon-user"
                                href="#"
                                role="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                {{ user_name }} <span class="caret"></span>
                            </a>

                            <div
                                class="dropdown-menu dropdown-menu-right"
                                aria-labelledby="navbarDropdown"
                            >
                                <a
                                    class="dropdown-item"
                                    href="/logout"
                                    onclick="event.preventDefault();
                                                    document.getElementById('logout-form').submit();"
                                >
                                    Logout
                                </a>

                                <form
                                    id="logout-form"
                                    action="/logout"
                                    method="POST"
                                    style="display: none;"
                                >
                                    <input
                                        type="hidden"
                                        name="_token"
                                        id="csrf-token"
                                        :value="csrf_token"
                                    />
                                </form>
                                <a class="dropdown-item" href="/password">
                                    Change Password
                                </a>
                                <a class="dropdown-item" href="/register"
                                    >Create New Administrator</a
                                >
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

        <div v-if="loadingData" class="loading-indicator">
            <h1 class="text-center" style="line-height:100px;">
                <span class="icon-spin4 animate-spin"></span>
                Loading...
            </h1>
        </div>

        <div class="container" style="padding-bottom:15px; padding-top:70px;">
            <div v-if="errorMessage" class="row">
                <div class="col-md-12 mt-5 pt-5">
                    <h1 class="text-center text-danger icon-cancel-circle">
                        Application Error
                    </h1>
                    <h1 class="text-center text-danger">
                        {{ errorMessage }}
                    </h1>
                </div>
            </div>
            <div v-else id="accordion">
                <div v-for="map in maps" v-bind:key="map.id" class="card">
                    <div
                        class="card-header"
                        :id="`mapCardHeading${map.id}`"
                        data-toggle="collapse"
                        :data-target="`#mapCardBody${map.id}`"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                    >
                        <h5 class="mb-0">
                            <button class="btn btn-link">
                                {{ map.text }}
                            </button>
                        </h5>
                    </div>

                    <div
                        :id="`mapCardBody${map.id}`"
                        class="collapse"
                        :aria-labelledby="`mapCardHeading${map.id}`"
                        data-parent="#accordion"
                    >
                        <div class="card-body">
                            <ul>
                                <li>
                                    <router-link
                                        :to="`/map/overview/${map.id}`"
                                        class="btn btn-link"
                                        >{{ map.text }} Overview</router-link
                                    >
                                </li>
                                <li
                                    v-for="block in map.blocks"
                                    v-bind:key="block.id"
                                >
                                    <router-link
                                        :to="`/map/block/${map.id}/${block.id}`"
                                        class="btn btn-link"
                                        >{{ block.text }}</router-link
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    data() {
        return {
            maps: [],
            errorMessage: null,
            is_admin,
            dnc_count,
            csrf_token,
            user_name,
            loadingData: false,
            lastUpdate: null,
            eTag: null
        };
    },
    methods: {
        collapseNav: function() {
            $("#navbarSupportedContent").collapse("hide");
        },
        onServiceWorkerMessage: function(event) {
            var eventUrl = new URL(event.data.url);
            if (
                event.data.type == "refresh" &&
                eventUrl.pathname == "/mapdata" &&
                event.data.eTag != this.eTag
            ) {
                this.loadListData(false);
            }
        },
        loadListData: function() {
            axios
                .get("/mapdata")
                .then(response => {
                    this.loadingData = false;
                    this.maps = response.data.mapData;
                    this.dnc_count = response.data.details.dnc_count;
                    this.lastUpdate = response.data.details.lastUpdate;
                    this.eTag = response.headers.get("ETag");

                    // Force repaint after data loads
                    // This is a hacky workaround for a bug in
                    // mobile safari where part of the list is
                    // not rendered until the page is scrolled
                    setTimeout(() => {
                        window.scrollTo(0, window.scrollY + 1);
                        window.scrollTo(0, window.scrollY - 1);
                    }, 100);
                })
                .catch((error, response) => {
                    this.loadingData = false;
                    this.errorMessage = error.message;
                    console.log(error);
                });
        }
    },
    mounted() {
        if ("serviceWorker" in navigator) {
            // Handler for messages coming from the service worker
            navigator.serviceWorker.addEventListener(
                "message",
                this.onServiceWorkerMessage
            );
        }

        this.loadListData();
    },
    beforeDestroy() {
        if ("serviceWorker" in navigator) {
            // Handler for messages coming from the service worker
            navigator.serviceWorker.removeEventListener(
                "message",
                this.onServiceWorkerMessage
            );
        }
    }
};
</script>
